module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/axios/index.js
// module id = 179
// module chunks = 7011981053767 83246993240447 95715928098905 213534597649335